import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader } from 'components/loader/loader';
import { useGlobalState } from 'store/reducers/reducer';
import { confirmEmail } from 'store/sagas/sagas';
import { getQueryVariable } from 'utils/url';
export const Confirm = () => {
    const { asyncDispatch } = useGlobalState();
    const navigate = useNavigate();
    const [message, setMessage] = useState('');
    const token = getQueryVariable('t');
    useEffect(() => {
        if (!token) {
            setMessage('Check your email please');
            return;
        }
        // Only redirect on success: a failed confirm leaves the message on screen
        // instead of bouncing to /signin, and `replace` keeps Back from re-POSTing
        // the now-consumed token.
        let timer;
        asyncDispatch(confirmEmail(token))
            .then(() => {
            setMessage('Thanks for confirming your email.');
            timer = setTimeout(() => {
                navigate('/account', { replace: true });
            }, 3000);
        })
            .catch((error) => {
            console.error(error);
            setMessage(error.message);
        });
        return () => {
            clearTimeout(timer);
        };
    }, [token]);
    return (React.createElement("div", { className: "account u-flex-row g-page-without-header-footer u-align-vertical-center u-align-horizontal-center" },
        React.createElement("div", { className: "u-flex u-align-vertical-center" }, message ? React.createElement("span", null, message) : React.createElement(Loader, null))));
};
